import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Roles from "@/pages/roles/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import RoleDetail from "@/pages/role/page";
import Community from "@/pages/community/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "roles", element: <Roles /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "role/:id", element: <RoleDetail /> },
      { path: "community", element: <Community /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> }
    ]
  }
];

export default routes;